
	import {
		Component,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	import {
		getSkusByProductId,
		getActivity
	} from '@/api/supplier'

	import {
		maxspecifications
	} from '@/utils/config';
	@Component({
		name: 'buy-more-discount',
	})
	export default class BuyMoreDiscount extends Vue {
		@Prop({}) private productId!: number;
		private config: any = []
		private skuDetail: any = []
		private skuDetailMap: any = {}
		private skuList: any = []
		private totalSku: any = []
		private plugin: any = []
		private isCreate: boolean = true
		private activityId: number = 0
		//最多添加规格数
		private specificationsNum = maxspecifications

		private mounted() {

			this.getSkus()
		}

		private changeroutuan(e,i,n){
			if(this.config[n].rule_list[i].RouTuanPrice>this.config[n].rule_list[i].FirstRolePrice){
				this.config[n].rule_list[i].RouTuanPrice = ''
				this.$message.error('公司拿货价需低于级别拿货价')
				return 
			}
		}

		/**
		 * @func 添加规则
		 */
		private addRule() {
			if (this.config.length >= 3) {
				this.$message(`最多配置3档优惠`)
				return false
			}
			this.config.push({
				Id: 0,
				quantity: '',
				rule_list: JSON.parse(JSON.stringify(this.skuDetail)),
				SpecBacthGroupPrice:'',
				SpecBacthRouTuanPrice:'',
				SpecBacthSpreadPrice:'',
				SpecBacthThirdRolePrice:'',
				SpecBacthSecondRolePrice:'',
				SpecBacthFirstRolePrice:'',
			})
		}

		/**
		 * @func 移除规则
		 */
		private removeRule(index: number) {
			this.config.splice(index, 1)
			this.totalSku.splice(index, 1)
			this.transformObj(this.config)
		}

		/**
		 * @func 获取商品sku详情
		 */
		private async getSkus() {
			try {
				const res: any = await getSkusByProductId({
					ProductId: this.productId,
				})
				let skuMap = []
				this.skuDetail = []
				this.skuList = []
				
				var obj = res.Result
				//计算规格类型列表
				for(let i = 0;i<this.specificationsNum;i++){
					let key = 'SpecTitle'+(i==0?'':i+1)
					if (obj[key]){
						this.skuList.push(obj[key])
					}
				}
				// console.log(this.skuList)
				
				if (obj.ProductSpecList && obj.ProductSpecList.length) {
					obj.ProductSpecList.sort((a,b)=>{
						return a.Sort - b.Sort
					}).forEach((item: any, index: number) => {
						// skuMap[item.Id] = item;
						// item['SecondRolePrice'] = parseFloat(((item['ThirdRolePrice']||0) - (item['SpreadPrice']||0)).toFixed(2))
						// item['FirstRolePrice'] = parseFloat(((item['SecondRolePrice']||0) - (item['SpreadPrice']||0)).toFixed(2))
						// item['RouTuanPrice'] = parseFloat(((item['FirstRolePrice']||0) - (item['SpreadPrice']||0)).toFixed(2))
						item.ProductSpecId = item.Id;
						this.skuDetail.push(item);

					})
				}
				if (obj.ProductBuyMoreDealsList && obj.ProductBuyMoreDealsList.length){
					this.isCreate = false;
					this.config = obj.ProductBuyMoreDealsList.map((item,index)=>{
						item.quantity = item.StartOrDecreaseCount;
						//新增的规格 如果原来设置的没有这个 就新增 全部数据为0
						// console.log(item,123)
						this.skuDetail.map((v)=>{
							if(!item.ProductBuyMoreDealsDetailList.some(x=>x.ProductSpecId==v.Id)){
								item.ProductBuyMoreDealsDetailList.push({
									GroupPrice: item.SpecBacthGroupPrice,
									Id: 0,
									ProductBuyMoreDealsId: 0,
									ProductSpecId: v.Id,
									RouTuanPrice: item.RouTuanPrice,
									SpecValue:v.SpecValue,
									SpecValue2:v.SpecValue2,
									SpecValue3:v.SpecValue3,
									SpreadPrice: item.SpecBacthSpreadPrice,
									ThirdRolePrice: item.SpecBacthThirdRolePrice,
									SecondRolePrice: item.SecondRolePrice,
									FirstRolePrice: item.FirstRolePrice,
								})
							}
						})
						item.rule_list = item.ProductBuyMoreDealsDetailList.map((obj)=>{
							// obj['SecondRolePrice'] = parseFloat(((obj['ThirdRolePrice']||0) - (obj['SpreadPrice']||0)).toFixed(2))
							// obj['FirstRolePrice'] = parseFloat(((obj['SecondRolePrice']||0) - (obj['SpreadPrice']||0)).toFixed(2))
							// obj['RouTuanPrice'] = parseFloat(((obj['FirstRolePrice']||0) - (obj['SpreadPrice']||0)).toFixed(2))
							// console.log(obj)
							return obj;
						});
						// console.log(item)
						this.totalSku.push({
							GroupPrice: item.SpecBacthGroupPrice,
							SpreadPrice: item.SpecBacthSpreadPrice,
							ThirdRolePrice:item.SpecBacthThirdRolePrice,
							RouTuanPrice:item.SpecBacthRouTuanPrice,
							SecondRolePrice:item.SpecBacthSecondRolePrice,
							FirstRolePrice:item.SpecBacthFirstRolePrice,
						})
						return item;
					})
					
					this.transformObj(this.config)
				}else{
					this.isCreate = true
					this.addRule()
					this.transformObj(this.config)
				}

			} catch (err) {
				console.log(err)
			}
		}

		/**
		 * @func 全部修改价格
		 */
		private changAllPricd(e: any, type: string, index: number) {
			// console.log((this.config[index].rule_list),type)
			let two = /^\d+(\.\d{1,2})?$/
			if(Number(this.config[index][type])<0 || !two.test(this.config[index][type])){
				this.config[index][type] = ''
				return 
			}
			
			this.config[index].rule_list.map((item: any) => {
				if(type == 'SpecBacthSecondRolePrice'){
					item['SecondRolePrice'] = this.config[index][type]
				}else if(type == 'SpecBacthFirstRolePrice'){
					item['FirstRolePrice'] = this.config[index][type]
				}else{
					item[type.replace('SpecBacth','')] = this.config[index][type]
				}
				// console.log(item,this.config[index])
				// if ((type === 'SpecBacthThirdRolePrice' || type === 'SpecBacthSpreadPrice') && (item['ThirdRolePrice'])) {
				// 	item['SecondRolePrice'] = parseFloat(((item['ThirdRolePrice']||0) - (item['SpreadPrice']||0)).toFixed(2))
				// 	item['FirstRolePrice'] = parseFloat(((item['SecondRolePrice']||0) - (item['SpreadPrice']||0)).toFixed(2))
				// 	item['RouTuanPrice'] = parseFloat(((item['FirstRolePrice']||0) - (item['SpreadPrice']||0)).toFixed(2))
				// }
			})


			if(type === 'SpecBacthRouTuanPrice'){
				let isConform = false
				for(let item of this.config[index].rule_list){
					if(item.FirstRolePrice<item.RouTuanPrice){
						isConform = true
						break
					}
				}
				if(isConform){
					this.$message.error('公司拿货价需低于级别拿货价')
					this.config[index][type] = ''
					this.config[index].rule_list = this.config[index].rule_list.map((v:any)=>{
						v.RouTuanPrice = ''
						return v
					})
				}
			}
			this.transformObj(this.config)
		}

		/**
		 * @func 修改单个总代价格或者差价
		 * @param fIndex 父层级index
		 * @param cIndex 子层级index
		 */
		private wathhxlc(e: any, fIndex: number, cIndex: number) {
			// console.log(fIndex,cIndex)
			let item = this.config[fIndex].rule_list[cIndex]
			// if (item.ThirdRolePrice && item.SpreadPrice) {
				// this.config[fIndex].rule_list[cIndex].SecondRolePrice = parseFloat(((item.ThirdRolePrice||0) - (item.SpreadPrice||0))
				// 	.toFixed(2))
				// this.config[fIndex].rule_list[cIndex].FirstRolePrice = parseFloat(((item.SecondRolePrice||0) - (item.SpreadPrice||0))
				// 	.toFixed(2))
				// this.config[fIndex].rule_list[cIndex].FirstRolePrice = parseFloat(((item.SecondRolePrice||0) - (item.SpreadPrice||0))
				// 	.toFixed(2))
				// this.config[fIndex].rule_list[cIndex].RouTuanPrice = parseFloat(((item.FirstRolePrice||0) - (item.SpreadPrice||0))
				// 	.toFixed(2))
			// }
			// console.log(this.config)
			this.transformObj(this.config)
		}

		/**
		 * @func 转换结果结构
		 */
		private transformObj(list: any) {
			this.$emit('change', {
				data: this.config,
				is_create: this.isCreate,
				id: this.activityId
			})
		}

	}
